/**
 * Survey: PROJECT - FINAL IMPACT
 * Question: How has your career status changed after the program?
 * 
 * == final
 * career_status_biz_t1
 * 
 * @param props 
 * @returns 
 */
export const entrepreneursWhoStartedNewBusinessTotalCalculation = (props: any) => {
    const count = props.finalSubmissions.filter(
        (submission: any) => ['BIZ_SCALE_T1', 'BIZ_NEW_T1'].includes(submission.career_status_biz_t1)
    ).length;

    return (count / props.finalSubmissions.length * 100).toFixed(2);
}